__turbopack_context__.v({
  "backBtn": "ChancenkarteCalculator-module__Ur3d9q__backBtn",
  "boostTip": "ChancenkarteCalculator-module__Ur3d9q__boostTip",
  "breakdown": "ChancenkarteCalculator-module__Ur3d9q__breakdown",
  "breakdownBar": "ChancenkarteCalculator-module__Ur3d9q__breakdownBar",
  "breakdownFill": "ChancenkarteCalculator-module__Ur3d9q__breakdownFill",
  "breakdownLabel": "ChancenkarteCalculator-module__Ur3d9q__breakdownLabel",
  "breakdownPts": "ChancenkarteCalculator-module__Ur3d9q__breakdownPts",
  "breakdownRow": "ChancenkarteCalculator-module__Ur3d9q__breakdownRow",
  "breakdownTitle": "ChancenkarteCalculator-module__Ur3d9q__breakdownTitle",
  "calculator": "ChancenkarteCalculator-module__Ur3d9q__calculator",
  "ctaPrimary": "ChancenkarteCalculator-module__Ur3d9q__ctaPrimary",
  "ctaSecondary": "ChancenkarteCalculator-module__Ur3d9q__ctaSecondary",
  "fadeIn": "ChancenkarteCalculator-module__Ur3d9q__fadeIn",
  "fillActive": "ChancenkarteCalculator-module__Ur3d9q__fillActive",
  "fillZero": "ChancenkarteCalculator-module__Ur3d9q__fillZero",
  "floatUp": "ChancenkarteCalculator-module__Ur3d9q__floatUp",
  "gaugeBar": "ChancenkarteCalculator-module__Ur3d9q__gaugeBar",
  "gaugeBar_borderline": "ChancenkarteCalculator-module__Ur3d9q__gaugeBar_borderline",
  "gaugeBar_notyet": "ChancenkarteCalculator-module__Ur3d9q__gaugeBar_notyet",
  "gaugeBar_qualifying": "ChancenkarteCalculator-module__Ur3d9q__gaugeBar_qualifying",
  "gaugeLabel": "ChancenkarteCalculator-module__Ur3d9q__gaugeLabel",
  "gaugeOf": "ChancenkarteCalculator-module__Ur3d9q__gaugeOf",
  "gaugeScore": "ChancenkarteCalculator-module__Ur3d9q__gaugeScore",
  "gaugeSvg": "ChancenkarteCalculator-module__Ur3d9q__gaugeSvg",
  "gaugeTrack": "ChancenkarteCalculator-module__Ur3d9q__gaugeTrack",
  "gaugeWrap": "ChancenkarteCalculator-module__Ur3d9q__gaugeWrap",
  "material-icons": "ChancenkarteCalculator-module__Ur3d9q__material-icons",
  "optionBtn": "ChancenkarteCalculator-module__Ur3d9q__optionBtn",
  "optionLabel": "ChancenkarteCalculator-module__Ur3d9q__optionLabel",
  "optionPoints": "ChancenkarteCalculator-module__Ur3d9q__optionPoints",
  "optionSelected": "ChancenkarteCalculator-module__Ur3d9q__optionSelected",
  "optionSublabel": "ChancenkarteCalculator-module__Ur3d9q__optionSublabel",
  "optionText": "ChancenkarteCalculator-module__Ur3d9q__optionText",
  "options": "ChancenkarteCalculator-module__Ur3d9q__options",
  "pointsChip": "ChancenkarteCalculator-module__Ur3d9q__pointsChip",
  "progressFill": "ChancenkarteCalculator-module__Ur3d9q__progressFill",
  "progressHeader": "ChancenkarteCalculator-module__Ur3d9q__progressHeader",
  "progressMeta": "ChancenkarteCalculator-module__Ur3d9q__progressMeta",
  "progressTrack": "ChancenkarteCalculator-module__Ur3d9q__progressTrack",
  "resultCard": "ChancenkarteCalculator-module__Ur3d9q__resultCard",
  "resultCtas": "ChancenkarteCalculator-module__Ur3d9q__resultCtas",
  "runningTotal": "ChancenkarteCalculator-module__Ur3d9q__runningTotal",
  "slideIn": "ChancenkarteCalculator-module__Ur3d9q__slideIn",
  "stepCard": "ChancenkarteCalculator-module__Ur3d9q__stepCard",
  "stepIcon": "ChancenkarteCalculator-module__Ur3d9q__stepIcon",
  "stepLabel": "ChancenkarteCalculator-module__Ur3d9q__stepLabel",
  "stepQuestion": "ChancenkarteCalculator-module__Ur3d9q__stepQuestion",
  "thresholdNote": "ChancenkarteCalculator-module__Ur3d9q__thresholdNote",
  "tier_borderline": "ChancenkarteCalculator-module__Ur3d9q__tier_borderline",
  "tier_notyet": "ChancenkarteCalculator-module__Ur3d9q__tier_notyet",
  "tier_qualifying": "ChancenkarteCalculator-module__Ur3d9q__tier_qualifying",
  "verdictBadge": "ChancenkarteCalculator-module__Ur3d9q__verdictBadge",
  "verdict_borderline": "ChancenkarteCalculator-module__Ur3d9q__verdict_borderline",
  "verdict_notyet": "ChancenkarteCalculator-module__Ur3d9q__verdict_notyet",
  "verdict_qualifying": "ChancenkarteCalculator-module__Ur3d9q__verdict_qualifying",
});
